/**
 * Where the browser sends API calls.
 *
 * It used to fall back to the absolute `http://helinoxvn.com:5000`, which baked a hard http:// URL
 * into the production bundle. The day the site answers on https that URL becomes mixed content and
 * the browser blocks every call — the page loads and nothing works. Same-origin has neither problem:
 * nginx already proxies /api, /auth, /login and /portal-auth to the backend on both ports, and it is
 * what staging has been running on all along.
 *
 * REACT_APP_BACKEND_URL still wins when it is set, for a build that has to point somewhere else.
 */
export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  return '';
};

export const BACKEND_URL = getBackendUrl();

/* `${BACKEND_URL}/` is the site root once BACKEND_URL is empty — the SPA's own index.html, not the
   backend. nginx exposes the backend's root as /portal-auth for exactly this. */
export const getAuthCheckUrl = () => (BACKEND_URL ? `${BACKEND_URL}/` : '/portal-auth');
